import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import {
  GROUP_TYPE_QUERY_PARAM,
  THERAPY_CATEGORY_QUERY_PARAM,
} from "../group-appointment-constant";

export type UseGroupSessionFilters = {
  groupType: string;
  therapyCategory: string;
  setGroupType: (value: string | null) => void;
  setTherapyCategory: (value: string | null) => void;
};

/**
 * Group type and therapy category the sessions list is narrowed by. They live
 * in the URL, so the filter panel and the list read one source.
 *
 * @author Rajkumar Rathod
 */
export const useGroupSessionFilters = (): UseGroupSessionFilters => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFilter = useCallback(
    (key: string, value: string | null) => {
      if (value) searchParams.set(key, value);
      else searchParams.delete(key);
      setSearchParams(searchParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return {
    groupType: searchParams.get(GROUP_TYPE_QUERY_PARAM) ?? "",
    therapyCategory: searchParams.get(THERAPY_CATEGORY_QUERY_PARAM) ?? "",
    setGroupType: (value) => setFilter(GROUP_TYPE_QUERY_PARAM, value),
    setTherapyCategory: (value) =>
      setFilter(THERAPY_CATEGORY_QUERY_PARAM, value),
  };
};
